import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "@/shared/components/RouteError";
import { RoutePending } from "@/shared/components/RoutePending";

const searchSchema = z.object({
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

// smell: orphan page with no link anywhere; candidate for removal.
/**
 * @purpose-exempt orphan page, no link anywhere; removal candidate
 */
export const Route = createFileRoute("/app/admin/kpis/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
